import { Component, OnInit, Input, input } from '@angular/core';
import { IconNames } from '@app/shared/enums/icon-names';
import { InfoAccordionContentComponent } from './info-accordion-content/info-accordion-content.component';
import { InfoAccordionHeaderComponent } from './info-accordion-header/info-accordion-header.component';

// https://github.com/NetanelBasal/ng-accordion-tutorial/tree/master/@app

@Component({
  selector: 'app-info-accordion',
  styleUrls: ['./info-accordion.component.scss'],
  templateUrl: './info-accordion.component.html',
  imports: [InfoAccordionHeaderComponent, InfoAccordionContentComponent],
})
export class InfoAccordionComponent implements OnInit {
  IconNames = IconNames;

  testId = input.required<string>();
  @Input() iconName: IconNames;
  @Input() displayIcon: boolean = true;
  @Input() initialOpenState: boolean;
  @Input() type: 'critical' | 'neutral' = 'neutral';

  isOpen: boolean;

  ngOnInit(): void {
    this.isOpen = this.initialOpenState;
  }
}
